<template>
  <div class="fieldset">
    <p class="subtitle">{{ custom ? identifier : $t(`filters.${identifier}`) }}</p>
    <fieldset v-for="(item, idx) in segment" :key="idx">
      <input :id="`${identifier}-${idx}`" v-model="item.enabled" type="checkbox" />
      <label :for="`${identifier}-${idx}`"
        >{{ item.value ? $t(item.value) : $t('notProvided') }} <small>({{ item.count }})</small></label
      >
    </fieldset>
  </div>
</template>

<script>
export default {
  props: ['identifier', 'segment', 'custom'],
};
</script>

<style lang="scss"></style>
